import { MapUtils } from '../../utility/map-utils.js';
import { DataModel, DataModelBuilder, isSameData, SerializationContext, SerializedData } from '../dto/dto.js';
import { PhoneNumber } from './phone-number.js';

export class FestivalCompetitionEntry extends DataModel {
  static readonly TYPE_ID: string = '6c37620e0be94e6fac2f7ab82ed3b673';

  constructor(
    public readonly uniqueId: string,
    public readonly teamName: string,
    public readonly teamLeadName: string,
    public readonly teamLeadPhoneNumber: PhoneNumber,
    public readonly teamLeadEmailAddress: string,
    public readonly teamHeadcount: number,
  ) {
    super();
  }

  get $typeId(): string {
    return FestivalCompetitionEntry.TYPE_ID;
  }

  static fromMap(context: SerializationContext, map: SerializedData): FestivalCompetitionEntry {
    return new FestivalCompetitionEntry(
        MapUtils.get<string>(map, 'uniqueId'),
        MapUtils.get<string>(map, 'teamName'),
        MapUtils.get<string>(map, 'teamLeadName'),
        PhoneNumber.mustDecode(MapUtils.get<string>(map, 'teamLeadPhoneNumber')),
        MapUtils.get<string>(map, 'teamLeadEmailAddress'),
        MapUtils.get<number>(map, 'teamHeadcount'),
    );
  }

  toMap(context: SerializationContext): SerializedData {
    return {
      'uniqueId': this.uniqueId,
      'teamName': this.teamName,
      'teamLeadName': this.teamLeadName,
      'teamLeadPhoneNumber': this.teamLeadPhoneNumber.encode(),
      'teamLeadEmailAddress': this.teamLeadEmailAddress,
      'teamHeadcount': this.teamHeadcount,
    };
  }

  clone(): this {
    return new FestivalCompetitionEntry(
        this.uniqueId,
        this.teamName,
        this.teamLeadName,
        this.teamLeadPhoneNumber.clone(),
        this.teamLeadEmailAddress,
        this.teamHeadcount,
    ) as this;
  }

  isSame(other: this): boolean {
    if(other === this) {
      return true;
    }

    return other.uniqueId === this.uniqueId &&
        other.teamName === this.teamName &&
        other.teamLeadName === this.teamLeadName &&
        isSameData(other.teamLeadPhoneNumber, this.teamLeadPhoneNumber) &&
        other.teamLeadEmailAddress === this.teamLeadEmailAddress &&
        other.teamHeadcount === this.teamHeadcount;
  }
}

export class FestivalCompetitionEntryBuilder extends DataModelBuilder<FestivalCompetitionEntry> {
  build(context: SerializationContext, map: SerializedData): FestivalCompetitionEntry {
    return FestivalCompetitionEntry.fromMap(context, map);
  }
}
